import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image", "loading", "title"];

  // Loads the gauge photo in the modal.
  // Fired when modal is shown.
  open(event) {
    // Get the button that triggered the modal.
    // Button's data attributes have photo title and source URL.
    const trigger = event.relatedTarget;
    if (!trigger) return;

    // Set modal title
    this.titleTarget.textContent = trigger.dataset.photoTitle || "Gauge Photo";
    this.showLoading("Loading photo...");
    this.imageTarget.removeAttribute("src");
    // Set image source
    this.imageTarget.src = trigger.dataset.photoSrc;
  }

  // Resets modal state and clears the image when the preview closes.
  // Fires when modal is hidden.
  close() {
    this.imageTarget.hidden = true;
    this.imageTarget.removeAttribute("src");
    this.showLoading("Loading photo...");
    this.titleTarget.textContent = "Gauge Photo";
  }

  // Swaps the loading message for the loaded full-size photo.
  // Invoked by the image element's load event from index.html.erb.
  imageLoaded() {
    this.loadingTarget.hidden = true;
    this.imageTarget.hidden = false;
  }

  // Shows an error message when the full-size photo cannot load.
  // Invoked by the image element's error event from index.html.erb.
  imageFailed() {
    this.imageTarget.hidden = true;
    this.showLoading("Photo could not be loaded.");
  }

  // Updates and reveals the modal loading/status message.
  // Invoked internally by open(), close(), and imageFailed().
  showLoading(message) {
    this.loadingTarget.textContent = message;
    this.loadingTarget.hidden = false;
  }
}
